import { makeVar } from '@apollo/client'

export const favoritesVar = makeVar([])

export const reservationsVar = makeVar(0)